import { render, staticRenderFns } from "./ProfileInfoView.vue?vue&type=template&id=3fbbd85c&scoped=true&"
import script from "./ProfileInfoView.vue?vue&type=script&lang=ts&"
export * from "./ProfileInfoView.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileInfoView.vue?vue&type=style&index=0&id=3fbbd85c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbbd85c",
  null
  
)

export default component.exports